// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatingChooser_wrapper__YtPer"};